var render = function () {
  var _vm$sharedData, _vm$sharedData$tradeI, _vm$sharedData2, _vm$sharedData2$trade, _vm$sharedData3, _vm$sharedData4, _vm$sharedData4$trade, _vm$sharedData5, _vm$sharedData5$trade, _vm$sharedData6, _vm$sharedData6$trade;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.isLoadingPicklesValuation || _vm.isSubmitting,
      expression: "isLoadingPicklesValuation || isSubmitting"
    }]
  }, [_c('el-card', {
    staticClass: "application-form pb-child-none mb-4"
  }, [_c('div', {
    staticClass: "items-center flex justify-between",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Trade In Details")])]), _vm._v(" "), (_vm$sharedData = _vm.sharedData) !== null && _vm$sharedData !== void 0 && (_vm$sharedData$tradeI = _vm$sharedData.tradeIn) !== null && _vm$sharedData$tradeI !== void 0 && _vm$sharedData$tradeI.customerEstimatedTradeInValue ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Customer supplied valuation")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s((_vm$sharedData2 = _vm.sharedData) !== null && _vm$sharedData2 !== void 0 && (_vm$sharedData2$trade = _vm$sharedData2.tradeIn) !== null && _vm$sharedData2$trade !== void 0 && _vm$sharedData2$trade.customerEstimatedTradeInValue ? ("" + (_vm.numberWithCommas(_vm.sharedData.tradeIn.customerEstimatedTradeInValue))) : '--') + "\n            ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Is there finance owing")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.getTradeInBalance ? 'Yes' : 'No') + "\n            ")])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Finance owing")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.getTradeInBalance ? ("" + (_vm.numberWithCommas(_vm.getTradeInBalance))) : '--') + "\n            ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Trade in equity")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s((_vm$sharedData3 = _vm.sharedData) !== null && _vm$sharedData3 !== void 0 && _vm$sharedData3.tradeInEquityValue ? ("" + (_vm.numberWithCommas(_vm.sharedData.tradeInEquityValue))) : '--') + "\n            ")])])])], 1), _vm._v(" "), !((_vm$sharedData4 = _vm.sharedData) !== null && _vm$sharedData4 !== void 0 && (_vm$sharedData4$trade = _vm$sharedData4.tradeIn) !== null && _vm$sharedData4$trade !== void 0 && _vm$sharedData4$trade.wantsPicklesAppraisal) ? _c('el-form', {
    ref: "tradeInFormExists",
    staticClass: "compact-form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRulesExists
    }
  }, [_c('el-row', {
    staticClass: "mt-2",
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('el-form-item', {
    staticClass: "mb-4",
    attrs: {
      "prop": "consentCheckbox",
      "required": ""
    }
  }, [_c('el-checkbox', {
    model: {
      value: _vm.formData.consentCheckbox,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "consentCheckbox", $$v);
      },
      expression: "formData.consentCheckbox"
    }
  }, [_vm._v("\n                I have got consent from the customer to refer to Pickles Trade\n                in valuation\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "justify-end flex",
    attrs: {
      "sm": 12
    }
  }, [_c('el-button', {
    staticClass: "button-icon",
    staticStyle: {
      "color": "#004c93",
      "font-size": "0.75rem",
      "padding": "12px 20px",
      "background-color": "#e6f2ff",
      "border": "1px solid #004c93"
    },
    on: {
      "click": function ($event) {
        return _vm.submitTradeInForm(true);
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticClass: "mr-3",
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "src": "https://finance.pickles.com.au/favicon-180",
      "alt": "okay"
    }
  }), _vm._v(" "), _vm._v("\n                Refer to Pickles\n              ")])])], 1)], 1)], 1) : _vm._e()], 1) : _c('el-form', {
    ref: "tradeInForm",
    staticClass: "compact-form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "mb-2",
    attrs: {
      "label": "Customer Estimated Trade In Value",
      "prop": "customerEstimatedTradeInValue",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formData.customerEstimatedTradeInValue,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "customerEstimatedTradeInValue", $$v);
      },
      expression: "formData.customerEstimatedTradeInValue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "mb-2",
    attrs: {
      "label": "Finance Owing",
      "prop": "financeOwing"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formData.financeOwing,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "financeOwing", $$v);
      },
      expression: "formData.financeOwing"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt-2",
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-form-item', {
    staticClass: "mb-2",
    attrs: {
      "prop": "consentCheckbox",
      "required": ""
    }
  }, [_c('el-checkbox', {
    model: {
      value: _vm.formData.consentCheckbox,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "consentCheckbox", $$v);
      },
      expression: "formData.consentCheckbox"
    }
  }, [_vm._v("\n              I have got consent from the customer to refer to Pickles Trade\n              in valuation\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt-2 justify-end flex"
  }, [_c('el-button', {
    staticClass: "button-icon",
    staticStyle: {
      "color": "#004c93",
      "font-size": "0.75rem",
      "padding": "12px 20px",
      "background-color": "#e6f2ff",
      "border": "1px solid #004c93"
    },
    on: {
      "click": function ($event) {
        return _vm.submitTradeInForm(false);
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticClass: "mr-3",
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "src": "https://finance.pickles.com.au/favicon-180",
      "alt": "okay"
    }
  }), _vm._v("\n            Refer to Pickles\n          ")])])], 1)], 1)], 1), _vm._v(" "), (_vm$sharedData5 = _vm.sharedData) !== null && _vm$sharedData5 !== void 0 && (_vm$sharedData5$trade = _vm$sharedData5.tradeIn) !== null && _vm$sharedData5$trade !== void 0 && _vm$sharedData5$trade.wantsPicklesAppraisal ? _c('el-card', {
    staticClass: "application-form pb-child-none mb-4"
  }, [_c('div', {
    staticClass: "items-center flex justify-between",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Pickles Valuation\n        "), _vm.inspectionData ? _c('a', {
    staticClass: "pl-2",
    staticStyle: {
      "color": "#7100da"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.openViewInspectionDetail();
      }
    }
  }, [_vm._v(_vm._s(_vm.DOCUMENT_VIEW_LINK + ' Inspection'))]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Consented to get a trade-in quote from Pickles")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n            " + _vm._s((_vm$sharedData6 = _vm.sharedData) !== null && _vm$sharedData6 !== void 0 && (_vm$sharedData6$trade = _vm$sharedData6.tradeIn) !== null && _vm$sharedData6$trade !== void 0 && _vm$sharedData6$trade.wantsPicklesAppraisalConsentedAt ? _vm.format(new Date(_vm.sharedData.tradeIn.wantsPicklesAppraisalConsentedAt), 'dd/MM/yyyy hh:mm aaa') : '--') + "\n          ")])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-sm font-bolder mt-4"
  }, [_vm._v("Trade In Valuation")]), _vm._v(" "), _vm.latestTradeInValuation ? _c('div', {
    staticClass: "pt-2"
  }, [_c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Description")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.latestTradeInValuation.vehicleDescription || '--') + "\n            ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Status")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.makeCapitalCase(_vm.latestTradeInValuation.vehicleStatus) || '--') + "\n            ")])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Registration")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.latestTradeInValuation.registration || '--') + "\n            ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("VIN")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.latestTradeInValuation.vin || '--') + "\n            ")])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Pickles Valuation as Appraised")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(("" + (_vm.numberWithCommas(_vm.latestTradeInValuation.valuation))) || '--') + "\n            ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": 12
    }
  }, [_c('p', {
    staticClass: "text-xs font-extrabold"
  }, [_vm._v("Valuation Expiry Date")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm mt-1"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.format(new Date(_vm.latestTradeInValuation.expiryDate), 'dd/MM/yyyy hh:mm aaa') || '--') + "\n            ")])])])], 1)], 1) : _vm.isLoadingPicklesValuation ? _c('div', {
    staticClass: "pt-2"
  }) : _c('div', {
    staticClass: "pt-2"
  }, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v("The customer consented to obtain a trade in valuation from Pickles,\n        but we have not received an update from Pickles at this time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v("You can remind the customer to check their inbox for an email from\n        Pickles, and action the valuation process.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-sm font-bolder"
  }, [_vm._v("Email for customers:\n      "), _c('a', {
    staticClass: "text-primary",
    attrs: {
      "href": "mailto:visadmin@pickles.com.au",
      "target": "_blank"
    }
  }, [_vm._v("\n        visadmin@pickles.com.au\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-sm font-bolder"
  }, [_vm._v("Customer contact centre number:\n      "), _c('a', {
    staticClass: "text-primary",
    attrs: {
      "href": "tel:1300052392",
      "target": "_blank"
    }
  }, [_vm._v("\n        1300 052 392\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-sm font-bolder"
  }, [_vm._v("Email for CarClarity:\n      "), _c('a', {
    staticClass: "text-primary",
    attrs: {
      "href": "mailto:carclarity@pickles.com.au",
      "target": "_blank"
    }
  }, [_vm._v("\n        carclarity@pickles.com.au\n      ")])]), _vm._v(" "), _c('PicklesInspectionViewDialog', {
    attrs: {
      "inspection-data": _vm.inspectionData,
      "visible-sync": _vm.inspectionDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "mt-4 mb-8 justify-end flex"
  }, [_c('div', {
    staticClass: "border-r border-light-grey mr-6 pr-6"
  }, [_c('el-button', {
    staticClass: "w-auto",
    attrs: {
      "plain": "",
      "data-selector": "asset-details-back-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.backToPrevious();
      }
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "w-auto",
    attrs: {
      "data-selector": "asset-details-save-next-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.nextPage();
      }
    }
  }, [_vm._v("Next")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }